import CalendarToday from '@material-ui/icons/CalendarToday';
import * as React from 'react';
import { DSTextField } from '../mui/TextField';
import { DSTypography } from '../mui/Typography';
import { DatePickerButton } from './DatePickerButton';
import { useDateInput } from './use-date-input';

export interface DatePickerProps {
    className?: string;
    error?: string;
    label?: string;
    style?: React.CSSProperties;
    value?: Date;
    onChange?: (val?: Date) => void;
}

export function DatePicker(props: DatePickerProps): JSX.Element {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [displayValue, setDisplayValue] = useDateInput(inputRef, props.value, props.onChange);
    return (
        <>
            <DSTextField
                InputProps={{
                    endAdornment: (
                        <DatePickerButton icon={<CalendarToday />} value={props.value} onChange={props.onChange} />
                    ),
                }}
                className={props.className}
                error={!!props.error}
                inputRef={inputRef}
                label={props.label}
                style={props.style}
                value={displayValue}
                onChange={ev => setDisplayValue(ev.target.value)}
            />
            {!!props.error && <DSTypography color="error">{props.error}</DSTypography>}
        </>
    );
}
DatePicker.displayName = 'DatePicker';
